export default __webpack_public_path__ + "static/media/mg.731a7447.png";